import React from "react";

function CampaignList(props) {
  const { ads, setCampaign, tapes, selectedWeek, setSelectedWeek } = props;
  let weekSelect = [];
  for (let i = 1; i < 53; i++) {
    weekSelect.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }
  weekSelect = (
    <div className="week-select-title">
      <h3>Alkavat kampanjat viikolla </h3>
      <select
        value={selectedWeek}
        key={"weekSelect"}
        onChange={(event) => {
          setSelectedWeek(event.target.value);
        }}
      >
        {weekSelect}
      </select>
    </div>
  );

  return (
    <div>
      {weekSelect}
      <div>
        {ads.reduce((pre, cur, index, array) => {
          if (Number(cur.start) === Number(selectedWeek)) {
            if (
              index === 0 ||
              !(cur.campaignId === array[index - 1].campaignId)
            ) {
              const element = [];
              let i = index;
              let done = 0;
              let all = 0;

              do {
                const prod = array[i];
                element.push(prod);
                const a = tapes.reduce((pre1, cur1) => {
                  if (
                    cur1.campaignId === cur.campaignId &&
                    cur1.format === prod.format
                  )
                    return pre1 + Number(cur1.amount);
                  return pre1;
                }, 0);
                all += Number(prod.amount);
                done += a;
                i++;
              } while (array[i] && cur.campaignId === array[i].campaignId);
              const name =
                cur.client +
                " | " +
                element.filter((el) => el.ready === "X").length +
                "/" +
                element.length +
                " | " +
                Math.floor((done / all) * 100) +
                "%";
              pre.push(
                <div
                  className="campaign-item"
                  key={index}
                  onClick={() => {
                    setCampaign(cur.campaignId);
                    window.history.pushState(
                      { role: "teippaus", campaign: cur.campaignId },
                      "Campaign: " + cur.campaignId,
                      "?campaign=" + cur.campaignId
                    );
                  }}
                >
                  {name}
                </div>
              );
            }
          }
          return pre;
        }, [])}
      </div>
    </div>
  );
}

export default CampaignList;
